import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Loading } from "@/components/ui-kit";
import { PenLine, Clock, CheckCircle2, ChevronRight } from "lucide-react";

export default function WritingFeedback() {
  const [subs, setSubs] = useState(null);
  useEffect(() => { api.get("/writing").then((r) => setSubs(r.data)); }, []);
  if (!subs) return <Loading />;

  const pending = subs.filter((s) => s.status === "submitted");
  const done = subs.filter((s) => s.status === "reviewed");

  const Card = ({ s }) => (
    <Link to={`/tutor/writing/${s.id}`} data-testid={`writing-sub-${s.id}`} className="ember-card ember-card-hover flex items-center gap-4 p-5">
      <span className={`grid h-11 w-11 place-items-center rounded-xl ${s.status === "submitted" ? "bg-[#FFFBEB] text-[#D97706]" : "bg-[#ECFDF5] text-[#059669]"}`}>
        {s.status === "submitted" ? <Clock className="h-5 w-5" /> : <CheckCircle2 className="h-5 w-5" />}
      </span>
      <div className="min-w-0 flex-1">
        <div className="truncate font-heading font-bold text-[#1E1B2E]">{s.student_name}</div>
        <div className="mt-0.5 flex flex-wrap gap-x-3 text-xs text-[#948EAB]">
          <span className="font-semibold text-[#7C3AED]">{s.program_name}</span>
          <span>{s.section_name}</span><span>{s.word_count} words</span>
        </div>
      </div>
      <ChevronRight className="h-5 w-5 text-[#C4B5FD]" />
    </Link>
  );

  return (
    <div className="animate-fade-up">
      <PageHeader title="Writing Submissions" subtitle="Review student writing and provide rubric-based feedback." />
      <h2 className="mb-3 flex items-center gap-2 font-heading text-lg font-bold text-[#1E1B2E]"><PenLine className="h-4 w-4 text-[#D97706]" /> Awaiting feedback ({pending.length})</h2>
      <div className="grid gap-3">
        {pending.length === 0 ? <div className="ember-card py-10 text-center text-sm text-[#948EAB]">Nothing awaiting feedback.</div> : pending.map((s) => <Card key={s.id} s={s} />)}
      </div>
      <h2 className="mb-3 mt-8 font-heading text-lg font-bold text-[#1E1B2E]">Reviewed ({done.length})</h2>
      <div className="grid gap-3">
        {done.map((s) => <Card key={s.id} s={s} />)}
      </div>
    </div>
  );
}
